(function(){
  function setupHat(root){
    if(!root || root.dataset.spPatchJs==='ready') return;
    root.dataset.spPatchJs='ready';
    const patch=root.querySelector('[data-sp-live-patch]');
    if(!patch) return;

    const shapeStyles={
      'Patch 1':{width:'138px',height:'80px',borderRadius:'0',clipPath:'polygon(10% 0,90% 0,100% 21%,95% 50%,100% 79%,90% 100%,10% 100%,0 79%,5% 50%,0 21%)'},
      'Patch 2':{width:'138px',height:'80px',borderRadius:'0',clipPath:'polygon(10% 0,90% 0,100% 16%,100% 84%,90% 100%,10% 100%,0 84%,0 16%)'},
      'Patch 3':{width:'130px',height:'76px',borderRadius:'50%',clipPath:'none'},
      'Patch 4':{width:'138px',height:'78px',borderRadius:'6px',clipPath:'none'},
      'Patch 5':{width:'90px',height:'90px',borderRadius:'50%',clipPath:'none'},
      'Patch 6':{width:'94px',height:'94px',borderRadius:'10px',clipPath:'none'}
    };
    const acrylic={
      'Brushed Stainless/Black':{background:'repeating-linear-gradient(96deg,#ededed 0 1px,#cecece 1px 2px,#e2e2e2 2px 3px,#bdbdbd 3px 4px)',borderColor:'#7e7e7e',boxShadow:'inset 0 1px 0 rgba(255,255,255,.7),0 3px 6px rgba(0,0,0,.22)'},
      'Black/Gold':{background:'linear-gradient(145deg,#252525,#050505)',borderColor:'#050505',boxShadow:'inset 0 0 0 2px rgba(198,155,61,.7),0 3px 6px rgba(0,0,0,.22)'},
      'Brushed Antique Gold/Black':{background:'repeating-linear-gradient(96deg,#d1aa54 0 1px,#a47b2e 1px 2px,#c49642 2px 3px,#866221 3px 4px)',borderColor:'#6d501e',boxShadow:'0 3px 6px rgba(0,0,0,.22)'},
      'Brushed Copper/Black':{background:'repeating-linear-gradient(96deg,#d38b69 0 1px,#a65c43 1px 2px,#c47657 2px 3px,#88462f 3px 4px)',borderColor:'#75402f',boxShadow:'0 3px 6px rgba(0,0,0,.22)'},
      'Stainless/Black/Blue':{background:'repeating-linear-gradient(96deg,#e1e1e1 0 1px,#c7c7c7 1px 2px,#d9d9d9 2px 3px,#bdbdbd 3px 4px)',borderColor:'#1b1b1b',boxShadow:'inset 0 0 0 3px #191919,inset 0 0 0 5px rgba(40,84,126,.75),0 3px 6px rgba(0,0,0,.22)'},
      'White/Red/Black':{background:'linear-gradient(145deg,#fff,#efefef)',borderColor:'#b72f2f',boxShadow:'inset 0 0 0 3px #111,inset 0 0 0 5px #b72f2f,0 3px 6px rgba(0,0,0,.2)'}
    };
    const leather={
      'Rawhide/Black':{background:'radial-gradient(circle at 28% 22%,rgba(255,255,255,.08) 0 1px,transparent 1.2px),linear-gradient(135deg,#d39a62,#a56539)',borderColor:'#704525',boxShadow:'inset 0 1px 0 rgba(255,255,255,.35),inset 0 -2px 3px rgba(0,0,0,.12),0 3px 6px rgba(0,0,0,.22)'},
      'Rustic/Gold':{background:'radial-gradient(circle at 28% 22%,rgba(255,255,255,.06) 0 1px,transparent 1.2px),linear-gradient(135deg,#6a3d26,#3b2116)',borderColor:'#28160f',boxShadow:'0 3px 6px rgba(0,0,0,.22)'},
      'Dark Brown/Black':{background:'linear-gradient(135deg,#4d3024,#281914)',borderColor:'#1b120e',boxShadow:'0 3px 6px rgba(0,0,0,.22)'},
      'Light Brown/Black':{background:'linear-gradient(135deg,#bd8557,#96623e)',borderColor:'#68422a',boxShadow:'0 3px 6px rgba(0,0,0,.22)'},
      'Black/Silver':{background:'linear-gradient(135deg,#242424,#080808)',borderColor:'#000',boxShadow:'inset 0 0 0 2px rgba(190,190,190,.45),0 3px 6px rgba(0,0,0,.22)'},
      'Black/Gold':{background:'linear-gradient(135deg,#242424,#080808)',borderColor:'#000',boxShadow:'inset 0 0 0 2px rgba(197,155,67,.48),0 3px 6px rgba(0,0,0,.22)'}
    };

    function placePatch(){
      if(root.dataset.model!=='Richardson R112') return;
      patch.style.setProperty('left','50%','important');
      patch.style.setProperty('top','49%','important');
    }
    function applyShape(){
      const checked=root.querySelector('input[name="properties[Patch Shape]"]:checked');
      const style=checked&&shapeStyles[checked.value];
      if(!style) return;
      Object.assign(patch.style,style);
      root.querySelectorAll('.sp-shape-choice').forEach(x=>x.classList.remove('is-selected'));
      checked.closest('.sp-shape-choice')?.classList.add('is-selected');
      placePatch();
    }
    function applyFinish(){
      const checked=root.querySelector('input[name="properties[Patch Finish]"]:checked');
      if(!checked) return;
      const map=root.dataset.material==='Acrylic'?acrylic:leather;
      const style=map[checked.value];
      if(style) Object.assign(patch.style,style);
      root.querySelectorAll('.sp-finish-choice').forEach(x=>x.classList.remove('is-selected'));
      checked.closest('.sp-finish-choice')?.classList.add('is-selected');
      root.querySelectorAll('.sp-shape-art').forEach(function(art){
        if(style?.background) art.style.background=style.background;
      });
      placePatch();
    }
    function applyAll(){applyShape();applyFinish();placePatch();}
    root.addEventListener('change',function(e){
      if(e.target.matches('input[name="properties[Patch Shape]"]')) applyShape();
      if(e.target.matches('input[name="properties[Patch Finish]"]')) applyFinish();
      if(e.target.matches('.sp-color-choice input')) setTimeout(placePatch,40);
    });
    applyAll();
    setTimeout(applyAll,250);
    setTimeout(placePatch,700);
  }
  function boot(){document.querySelectorAll('[data-sp-master-product][data-mode="hat"]').forEach(setupHat);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();

/* Sky Prints QA-only normalization for remaining hat products. */
(function(){
  const CHOCOLATE_BIRCH='https://cdn.shopify.com/s/files/1/0819/8959/9517/files/R112ChacolateChip_Birch.png?v=1735937885';
  const R112_CHARCOAL_BLACK='https://cdn.shopify.com/s/files/1/0819/8959/9517/files/R112Charcoal_Black.jpg?v=1735565422';

  function handle(){
    const m=window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m?m[1]:'';
  }
  function injectStyles(){
    if(document.getElementById('sp-special-hat-qa-styles')) return;
    const style=document.createElement('style');
    style.id='sp-special-hat-qa-styles';
    style.textContent=`
      #MainContent .sp-master-product[data-sp-special-hat] .sp-options-panel{padding:24px!important}
      #MainContent .sp-special-config{display:grid;gap:12px}
      #MainContent .sp-special-card{padding:15px;border:1px solid #e4e4df;border-radius:11px;background:#faf9f6}
      #MainContent .sp-special-card strong{display:block;font-size:13px;color:#171717;margin-bottom:4px}
      #MainContent .sp-special-card p{margin:0;font-size:11px;line-height:1.45;color:#555}
      #MainContent .sp-special-kicker{font-size:9px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:#73716b;margin-bottom:5px}
      #MainContent .sp-special-actions{display:grid;gap:9px;margin-top:16px}
      #MainContent .sp-special-actions a{display:flex;align-items:center;justify-content:center;min-height:46px;padding:10px 14px;border-radius:7px;text-decoration:none;font-weight:750;font-size:12px}
      #MainContent .sp-special-actions a:first-child{background:#161616;color:#fff}
      #MainContent .sp-special-actions a:not(:first-child){border:1px solid #cfcfca;color:#171717;background:#fff}
      #MainContent .sp-special-status{margin:14px 0 0;padding:12px;border:1px solid #e5dfd2;border-radius:8px;background:#fffaf0;font-size:10.5px;line-height:1.4;color:#5a5142}
      #MainContent .sp-master-product[data-sp-special-hat] .sp-price{font-size:18px!important;color:#5c5c58}
      #MainContent .sp-master-product[data-sp-special-hat] .sp-description{display:block!important;font-size:11.5px;line-height:1.5;color:#474747}
      #MainContent .sp-master-product[data-sp-special-hat] .sp-thumb-row{display:none!important}
      #MainContent .sp-master-product[data-sp-special-hat] .sp-trust-row{grid-template-columns:1fr!important}
      #MainContent .sp-master-product[data-sp-special-hat] .sp-live-patch[data-sp-uv-concept]{display:grid!important;background:linear-gradient(135deg,#ffffff 0 30%,#ff7a59 31% 48%,#ffd166 49% 62%,#4ecdc4 63% 78%,#4b7bec 79% 100%)!important;border:1px solid #888!important;color:#111!important;clip-path:polygon(10% 0,90% 0,100% 21%,95% 50%,100% 79%,90% 100%,10% 100%,0 79%,5% 50%,0 21%)!important;border-radius:0!important;width:138px!important;height:80px!important}
      #MainContent .sp-master-product[data-sp-special-hat] .sp-live-patch[data-sp-uv-concept] b{font-size:10px;line-height:1;text-align:center;padding:5px;background:rgba(255,255,255,.78);border-radius:3px;letter-spacing:.05em}
    `;
    document.head.appendChild(style);
  }
  function fixChocolateBirch(root){
    const h=handle();
    if(h!=='leather-patch-hat' && h!=='acrylic-buckle-patched-hat') return;
    root.querySelectorAll('.sp-color-choice').forEach(function(choice){
      const input=choice.querySelector('input');
      const label=(input?.value||choice.textContent||'').trim();
      if(label!=='Chocolate Chip / Birch') return;
      choice.dataset.image=CHOCOLATE_BIRCH;
      choice.dataset.mockupPending='false';
      choice.removeAttribute('data-mockup-pending');
      const pending=choice.querySelector('.sp-color-pending-thumb');
      if(pending){
        const img=document.createElement('img');
        img.src=CHOCOLATE_BIRCH;
        img.alt='Richardson 112 Chocolate Chip / Birch blank hat';
        img.loading='lazy';
        pending.replaceWith(img);
      }
      choice.querySelectorAll('.sp-pending-tag').forEach(x=>x.remove());
      if(input){
        input.addEventListener('change',function(){
          if(!input.checked) return;
          const main=root.querySelector('.sp-main-stage img');
          if(main){main.src=CHOCOLATE_BIRCH;main.alt='Richardson 112 Chocolate Chip / Birch blank hat';}
          const patch=root.querySelector('[data-sp-live-patch]');
          if(patch) patch.style.removeProperty('display');
        });
      }
    });
  }
  function specialMode(h){
    if(h==='full-color-uv-leatherette-patch-hat-richardson-112') return 'uv';
    if(h==='custom-embroidered-hat-richardson-112') return 'r112-emb';
    if(h==='custom-embroidered-seven-panel-hat-richardson-168') return 'r168-emb';
    if(h==='custom-embroidered-beanie') return 'sp08';
    return '';
  }
  function configFor(mode){
    if(mode==='uv') return {
      eyebrow:'FULL-COLOR UV PATCH HAT',
      cards:[
        ['Hat','Richardson 112 · Charcoal / Black master configuration'],
        ['Patch','Patch 1 · exact 3.00 in × 2.00 in finished size'],
        ['UV substrate','JDS LLA601 Ultra White Smooth leatherette · direct E1 flatbed candidate'],
        ['Launch gate','Full-size E1 print, cut, adhesion, placement, runtime and ink-use validation still required before checkout opens.']
      ],
      price:'Launch pricing pending physical validation',
      primary:'/pages/custom-patches',primaryLabel:'Start a custom patch request',
      secondary:'/pages/design-creation',secondaryLabel:'Get artwork help',
      status:'This UV hat remains hidden from public sale until the exact 3 × 2 production test passes and final cost is refreshed.'
    };
    if(mode==='r112-emb') return {
      eyebrow:'CUSTOM EMBROIDERED HAT',
      cards:[
        ['Hat','Richardson 112 trucker cap'],
        ['Decoration','Flat front embroidery is the launch standard'],
        ['Artwork','Logo/artwork review and embroidery preparation before production'],
        ['Fulfillment','Retail qty-1 route and landed pricing are being finalized separately from Company & Teams bulk orders.']
      ],
      price:'Retail pricing in final route verification',
      primary:'/pages/embroidery',primaryLabel:'Start an embroidery request',
      secondary:'/pages/business-team-printing',secondaryLabel:'Company & Teams orders',
      status:'Online checkout remains closed until the approved retail fulfillment route, launch colors, and landed qty-1 economics are verified.'
    };
    if(mode==='r168-emb') return {
      eyebrow:'CUSTOM EMBROIDERED SEVEN-PANEL HAT',
      cards:[
        ['Hat','Richardson 168 · true high-profile seven-panel · flat bill'],
        ['Decoration','Flat front embroidery is the launch standard'],
        ['Artwork','Logo/artwork review and embroidery preparation before production'],
        ['Fulfillment','Retail qty-1 route and landed pricing are being finalized separately from Company & Teams bulk orders.']
      ],
      price:'Retail pricing in final route verification',
      primary:'/pages/embroidery',primaryLabel:'Start an embroidery request',
      secondary:'/pages/business-team-printing',secondaryLabel:'Company & Teams orders',
      status:'Online checkout remains closed until the approved retail fulfillment route, launch colors, and landed qty-1 economics are verified.'
    };
    return {
      eyebrow:'CUSTOM EMBROIDERED BEANIE',
      cards:[
        ['Beanie','Sportsman SP08 · 8-inch knit beanie'],
        ['Decoration','Flat embroidery is the launch standard'],
        ['Artwork','Logo/artwork review and embroidery preparation before production'],
        ['Fulfillment','Launch colors, mixed-color digitizing rules, retail qty-1 route, and landed pricing are being finalized.']
      ],
      price:'Retail pricing in final route verification',
      primary:'/pages/embroidery',primaryLabel:'Start an embroidery request',
      secondary:'/pages/business-team-printing',secondaryLabel:'Company & Teams orders',
      status:'Online checkout remains closed until the final embroidery fulfillment route and landed retail economics are verified.'
    };
  }
  function stageSpecial(root){
    const h=handle(), mode=specialMode(h);
    if(!mode || root.dataset.spSpecialHat==='ready') return;
    root.dataset.spSpecialHat='ready';
    root.setAttribute('data-sp-special-hat',mode);
    injectStyles();
    const cfg=configFor(mode);
    const options=root.querySelector('.sp-options-panel');
    if(options){
      options.innerHTML='<div class="sp-special-config">'+cfg.cards.map(function(c){return '<div class="sp-special-card"><div class="sp-special-kicker">'+c[0]+'</div><strong>'+c[1]+'</strong></div>';}).join('')+'</div>';
    }
    const eyebrow=root.querySelector('.sp-eyebrow'); if(eyebrow) eyebrow.textContent=cfg.eyebrow;
    const price=root.querySelector('.sp-price'); if(price) price.textContent=cfg.price;
    const desc=root.querySelector('.sp-description'); if(desc) desc.style.display='block';
    root.querySelectorAll('.sp-qty-label,.sp-qty,.sp-add,.sp-upload,.sp-notes,.sp-setup-note').forEach(x=>x.style.display='none');
    const buy=root.querySelector('.sp-buy-panel');
    if(buy && !buy.querySelector('.sp-special-actions')){
      const box=document.createElement('div');
      box.innerHTML='<div class="sp-special-actions"><a href="'+cfg.primary+'">'+cfg.primaryLabel+'</a><a href="'+cfg.secondary+'">'+cfg.secondaryLabel+'</a><a href="/pages/design-creation">Design Creation & Artwork Help</a></div><div class="sp-special-status">'+cfg.status+'</div>';
      buy.appendChild(box);
    }
    const patch=root.querySelector('[data-sp-live-patch]');
    if(mode==='uv'){
      let main=root.querySelector('.sp-main-stage img');
      if(!main){
        main=document.createElement('img');
        const stage=root.querySelector('.sp-main-stage');
        if(stage) stage.prepend(main);
      }
      if(main){main.src=R112_CHARCOAL_BLACK;main.alt='Richardson 112 Charcoal / Black UV patch-hat concept base';}
      if(patch){patch.setAttribute('data-sp-uv-concept','true');patch.innerHTML='<b>FULL COLOR<br>UV</b>';}
      const stage=root.querySelector('.sp-main-stage');
      if(stage) stage.setAttribute('aria-label','Concept preview. Final full-size UV patch validation pending.');
    }else if(patch){
      patch.style.display='none';
    }
  }
  function boot(){
    document.querySelectorAll('[data-sp-master-product][data-mode="hat"]').forEach(function(root){fixChocolateBirch(root);stageSpecial(root);});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();